
import React, { useState, useEffect } from 'react';
import { Typography, TextField, Box, InputAdornment, IconButton, Stack } from '@mui/material';
import API from '../../../api';
import SaveIcon from '@mui/icons-material/Save'; // Import the floppy disk icon
import { startToast, updateToastSuccess, updateToastError } from '../../../utils/notification-loading';


const TelegramId = ({ item }) => {

  const [telegramValue, setTelegramValue] = useState('')

  useEffect(() => {
    setTelegramValue(item.telegramId)
  }, [item.telegramId])

  const handleUpdateClick = () => {
    startToast();
    API.postTelegram({ code: telegramValue })
      .then((response) => {
        updateToastSuccess("Telegram ID successfully set");
      })
      .catch((error) => {
        console.error("Errore nell'aggiornamento del Telegram ID:", error);
        updateToastError("Error during the operation");
      }); 
  };

  return (
    <Stack direction={"row"} spacing={2} height={"100%"}>
      <Stack direction={"column"} spacing={2} width={"100%"} justifyContent={"center"} alignItems={"center"}>
        <Typography variant="h4" >Telegram ID</Typography>
        <TextField
          id="telegramId"
          label="Telegram ID"
          variant="outlined"
          sx={{
            width: '300px',
          }}
          slotProps={{
            inputLabel:{
              shrink: true,
            },
            input: {
              endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={handleUpdateClick}
                  edge="end"
                  aria-label="update"
                >
                  <SaveIcon />
                </IconButton>
              </InputAdornment>
            ),
            }
          }}
          name="telegramId"
          value={telegramValue || null}
          onChange={(e) => {setTelegramValue(e.currentTarget.value)}}
        />
        <Typography variant="h6" fontWeight={400} sx={{textAlign: "center", whiteSpace: "pre-line", mt: 5}}>
          Check our bot @LECSTiresiaBot{"\n"} to receive notifications and{"\n"} see the network status.
        </Typography>
      </Stack>
      <Box sx={{display: "flex", justifyContent: "center", alignItems: "center", width: "100%"}}>
        <img src='/qr_code.png' alt="QR Code" style={{ height: '300px'}}/>
      </Box>
    </Stack>
  );
};

export default TelegramId;

/* 
<Box sx={[boxStyle, {p: 2, display: "flex", flexDirection: "row"}]}>
      <Box>
        <Typography variant="h4" marginBottom="1rem">Telegram ID</Typography>
        <Box
          component="form"
          noValidate
          sx={{ mt: 1, mb: 2, with: '100%' }}
        >
          <TextField
            id="telegramId"
            label="Telegram ID"
            variant="outlined"
            sx={{
              width: '200px',
            }}
            slotProps={{
              inputLabel:{
                shrink: true,
              },
              input: {
                endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleUpdateClick}
                    edge="end"
                    aria-label="update"
                  >
                    <SaveIcon />
                  </IconButton>
                </InputAdornment>
              ),
              }
            }}
            name="telegramId"
            value={telegramValue || null}
            onChange={(e) => {setTelegramValue(e.currentTarget.value)}}
          />
        </Box>
        <Typography variant="h6" fontWeight={400}>
          Check our bot @LECSTiresiaBot to receive notifications and see the network status.
        </Typography>
      </Box>
        <img src='/qr_code.png' alt="QR Code" style={{ height: '150px'}}/>
    </Box>
*/